<section class="section skills" id="skills">
    <div class="container">
        <div class="section-box">
            <div data-aos="fade-up" data-aos-duration="1000">
                <h3 class="section-title">
                    {{"Skills.Title" | translate}}
                </h3>
            </div>
            <div class="skills-grid">
                <div *ngFor='let group of "Skills.Groups" | translate' class="skill-group" data-aos="fade-up" data-aos-duration="1000">
                    <h4 class="skill-group-title">{{group.Name}}</h4>
                    <ul class="skill-tags">
                        <li *ngFor='let item of group.Items'>{{item}}</li>
                    </ul>
                </div>
            </div>

            <div class="certifications" data-aos="fade-up" data-aos-duration="1000">
                <h4 class="certifications-title">{{"Certifications.Title" | translate}}</h4>
                <ul class="certifications-list">
                    <li *ngFor='let cert of "Certifications.Items" | translate'>
                        <i class="fas fa-award" aria-hidden="true"></i>
                        <span>{{cert}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>
